import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import vuetify from "@/plugins/vuetify";
import store from "@/store";
import i18n from "@/plugins/i18n";
import "@/plugins/auth0";
import "@/plugins/tt";
import "@/plugins/countryflag";

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
